import _ from "lodash";
import { useEffect, useState } from "react";
import { InputOnChangeData } from "semantic-ui-react";
import { restRequest } from "../http";

export function useFormConnect<P, R>(data: P, url: string, method: 'post' | 'get' = 'post', parameterMapper?: (parameters: P) => any, loaded?: () => void): [R|undefined, React.Dispatch<React.SetStateAction<P>>, boolean] {
    const [queryData, setQueryData] = useState<P>(data)
    const [resultData, setResultData] = useState<R>()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true);
        restRequest<R>(url, queryData, method).then(setResultData).finally(() => setLoading(false))
    }, [queryData, url, method])

    return [resultData, d => {
        if (_.isFunction(d)) {
            setQueryData(v => parameterMapper ? parameterMapper(d(v)) : d(v));
        } else {
            setQueryData(parameterMapper ? parameterMapper({...d} as any) : {...d})
        }
    }, loading]
}

export function useFormData<T>(data: T): [T, (event: any, data: any) => void, React.Dispatch<React.SetStateAction<T>>] {
    const [formData, setFormData] = useState<T>(data);


    const setField = (event: any, data: any) => {
        setFormData(d => _.set<T>({...d} as any, data.name || event.target.name, data.value))
    }

    return [formData, setField, setFormData];
}


export function trimSetField(setField: (event: any, data: any) => void) {
    return (event: any, data: any) => {
        if (!data) {
            data = {name: event.target.name, value: event.target.value};
        }
        if (_.isString(data.value)) {
            data.value = data.value.trim();
        } else {
            console.error('trimSetField error: value is NOT string', data.value)
        }

        return setField(event, data);
    }
}